import {React, useContext} from 'react';
import AuthContext, { AuthProvider } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
// import { useContext } from 'react';


const Navbar = () => {
  let { logOutUser } = useContext(AuthContext);  
  const navigate = useNavigate();

  const handleDashboardClick = () => {
    navigate('/');
  };

  const handleLogoutClick = () => {
    // Add logout logic here if needed
    logOutUser();
    // navigate('/login');
  };

  return (
    <div style={navbarStyles.navbar}>
      <div style={navbarStyles.title}>Volunteer Dashboard</div>
      <div style={navbarStyles.actions}>
        <div style={navbarStyles.iconGroup} onClick={handleDashboardClick}>
          <DashboardIcon style={navbarStyles.icon} />
          <span style={navbarStyles.label}>DASHBOARD</span>
        </div>
        <div style={navbarStyles.iconGroup} onClick={handleLogoutClick}>
          <LogoutIcon style={navbarStyles.icon} />
        </div>
      </div>
    </div>
  );
};

const SelectScoutingReportType = () => {
  const navigate = useNavigate();

  const handleImageSubmitClick = () => {
    navigate('/scouting-media-list');
  };

  const handleFormSubmitClick = () => {
    navigate('/scouting-report-form');
  };

  return (
    <>
      <Navbar />
      <div style={styles.container}>
        <img
          src={require("../assets/images/mba-logo.png")}
          alt="Logo"
          style={{ width: '100px', height: 'auto', marginBottom: '5px' }}
        />
        <h2 style={styles.heading}>Scouting Report & Images - Choose Submission Type</h2>

        <h3 style={styles.subHeading}>How would you like to log your scouting experience?</h3>

        <div style={styles.optionsContainer}>
          <div style={styles.card} onClick={handleFormSubmitClick}>
            <img
              src={require("../assets/images/online-survey.png")}
              alt="Submit Form Icon"
              style={styles.cardIcon}
            />
            <h4 style={styles.cardTitle}>Submit Forms</h4>
            <p style={styles.cardDescription}>Log detailed information about your scouting experience and learnings.</p>
          </div>

          <div style={styles.card} onClick={handleImageSubmitClick}>
            <img
              src={require("../assets/images/picture.png")}
              alt="Upload Image Icon"
              style={styles.cardIcon}
            />
            <h4 style={styles.cardTitle}>Submit Images & Videos</h4>
            <p style={styles.cardDescription}>Share multimedia evidence to your scouting experience.</p>
          </div>
        </div>
      </div>
    </>
  );
};

// Navbar styles
const navbarStyles = {
  navbar: {
    backgroundColor: '#2e7d32',
    color: '#fff',
    padding: '15px 30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: '25px',
  },
  iconGroup: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '6px',
  },
  icon: {
    fontSize: '24px',
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
  },
};

// Main content styles
const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    maxWidth: '800px',
    margin: '40px auto',
    padding: '20px',
    border: '1px solid #ddd',
    borderRadius: '10px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    backgroundColor: '#fff',
    textAlign: 'center',
  },
  heading: {
    color: '#333',
    marginBottom: '10px',
  },
  location: {
    color: '#666',
    fontSize: '0.9em',
    marginBottom: '30px',
    borderBottom: '1px solid #eee',
    paddingBottom: '15px',
  },
  subHeading: {
    color: '#444',
    marginBottom: '25px',
  },
  optionsContainer: {
    display: 'flex',
    gap: '25px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  card: {
    flex: '1',
    minWidth: '280px',
    maxWidth: '350px',
    border: '1px solid #e0e0e0',
    borderRadius: '12px',
    padding: '30px 20px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    backgroundColor: '#f9f9f9',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardIcon: {
    width: '70px',
    height: '70px',
    marginBottom: '15px',
    opacity: '0.85',
  },
  cardTitle: {
    color: '#333',
    marginBottom: '10px',
    fontSize: '1.4em',
  },
  cardDescription: {
    color: '#666',
    fontSize: '0.95em',
    lineHeight: '1.5',
  },
};

export default SelectScoutingReportType;
